/**
 * ADM-ROLES.ROUTE
 * Set up roles for the account (admin, observers)
 */

import { WithTranslation, withTranslation } from "react-i18next"
import PageHeader from "@/components/page-header"
import NavApp from "@/nav/nav.app"
import AdmRolesWidget from "@/widgets/adm-roles.widget"
import AdmAddRoleWidget from "@/widgets/adm-add-role.widget"
import AdmRolesAffectWidget from "@/widgets/adm-roles-affect.widget"

import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { sessionEdit } from "@/redux/_session.actions"

type Props = WithTranslation

function AdmRolesRoute(props: Props) {
  const { t } = props
  const dispatch = useAppDispatch()
  const session = useAppSelector((state) => state._session)
  const rolesEnabled = session.accountOptions.roleManagementEnabled

  useEffect(() => {
    if (rolesEnabled && session.selectedRole !== "ADMIN") {
      dispatch(sessionEdit("selectedRole", "ADMIN"))
    }
  }, [rolesEnabled, session.selectedRole, dispatch])

  if (rolesEnabled && session.selectedRole !== "ADMIN") return <NavApp>{null}</NavApp>

  return (
    <NavApp>
      <PageHeader
        title={t(rolesEnabled ? "roles_administrators" : "roles")}
        subtitle={t(rolesEnabled ? "roles_administrators_help" : "roles_help")}>
        <AdmAddRoleWidget />
      </PageHeader>

      <AdmRolesWidget />

      {!rolesEnabled && <AdmRolesAffectWidget />}
    </NavApp>
  )
}

export default withTranslation()(AdmRolesRoute)
